import { useEffect, useRef, useState } from 'react';

export const useUpdateStatsigUser = (client, user) => {
  const [userLoading, setUserLoading] = useState(false);
  const prevUser = useRef(user);

  useEffect(() => {
    updateUser(prevUser, user, setUserLoading, client);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return { userLoading, user };
};

export const updateUser = async (prevUser, user, setUserLoading, client) => {
  /**
   * If we didn't check prevUser here, the app would enter an infinite render loop.
   * We specifically check if email is different so that if we logout and login with
   * a different user, statsig gets updated
   */
  if (prevUser.current.email !== user.email && !!user.email) {
    setUserLoading(true);
    await client.updateUserAsync(user);
    prevUser.current = user;
    setUserLoading(false);
  }
};
